// frontend/src/samkalp-admin/SamkalpAdminLoginPage.js
//
// Branded login for the unified Samkalp Admin Dashboard. Centre resolution
// uses a hardcoded list (SAMKALP_CENTRES) per the confirmed Phase 1 decision
// — no live backend-driven picker yet. Login itself is byte-for-byte the
// same flow as Studio's own LoginPage.js (POST /tenant/{slug}/token, store
// access_token, dispatch setUser) so the imported Studio components work
// unmodified.
import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import api from '../api/api';
import { setUser } from '../redux/slices/userSlice';
import { SAMKALP_CENTRES } from './samkalpCentres';

const NAVY = '#092957';
const GOLD = '#f1a51c';

const SamkalpAdminLoginPage = ({ onLogin }) => {
    const [centreSlug, setCentreSlug] = useState(SAMKALP_CENTRES[0]?.slug || '');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const dispatch = useDispatch();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); setError('');
        try {
            const res = await api.post(`/tenant/${centreSlug}/token`, new URLSearchParams({ username: email, password }));
            const { access_token } = res.data;

            const payload = JSON.parse(atob(access_token.split('.')[1]));
            if (payload.role !== 'tenant_admin' && payload.role !== 'system_admin') {
                setError('This login is for centre admins only.');
                setLoading(false);
                return;
            }
            localStorage.setItem('access_token', access_token);
            localStorage.setItem('samkalp_admin_slug', centreSlug);
            dispatch(setUser({ ...payload, email, tenant_slug: centreSlug, app_context: 'studio' }));
            onLogin({ slug: centreSlug });
        } catch (err) {
            setError(err.response?.data?.detail || 'Sign in failed. Please check your credentials.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', background: `linear-gradient(135deg, ${NAVY} 0%, #061f43 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
            <div style={{ width: '100%', maxWidth: 420, background: '#fff', borderRadius: 20, padding: '40px 36px', boxShadow: '0 24px 64px rgba(0,0,0,0.22)' }}>
                <div style={{ textAlign: 'center', marginBottom: 28 }}>
                    <div style={{ fontSize: 28, color: GOLD }}>☀</div>
                    <h3 style={{ fontWeight: 800, color: NAVY, margin: '8px 0 2px' }}>SAMKALP</h3>
                    <p style={{ color: '#72809b', fontSize: '0.85rem', margin: 0 }}>Admin Dashboard</p>
                </div>

                {error && <Alert variant="danger" className="py-2 small">{error}</Alert>}

                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label className="x-small fw-bold text-uppercase text-muted">Centre</Form.Label>
                        <Form.Select value={centreSlug} onChange={e => setCentreSlug(e.target.value)} required>
                            {SAMKALP_CENTRES.map(c => (
                                <option key={c.slug} value={c.slug}>{c.label}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="x-small fw-bold text-uppercase text-muted">Email</Form.Label>
                        <Form.Control type="email" value={email} onChange={e => setEmail(e.target.value)} required />
                    </Form.Group>
                    <Form.Group className="mb-4">
                        <Form.Label className="x-small fw-bold text-uppercase text-muted">Password</Form.Label>
                        <Form.Control type="password" value={password} onChange={e => setPassword(e.target.value)} required />
                    </Form.Group>
                    <Button type="submit" disabled={loading} style={{ width: '100%', background: NAVY, border: 'none', borderRadius: 10, padding: '12px', fontWeight: 700 }}>
                        {loading ? <Spinner animation="border" size="sm" /> : 'Sign In'}
                    </Button>
                </Form>
            </div>
        </div>
    );
};

export default SamkalpAdminLoginPage;
